import React from "react"
import { Box, Container, Heading, Text } from "@chakra-ui/react"

const Quote = ({ quote, author, alignment, theme }: GatsbyTypes.SanitySectionQuote) => (
  <Box
    bg={theme === "Dark" ? "brand.beige.dark" : "white"}
    textAlign={alignment?.toString() || "center"}
    my={3}
    w={["unset", "648px"]}
    margin={"auto"}
  >
    <Container>
      <Heading as="p" size="h2" mb={2}>
        &ldquo;{quote}&rdquo;
      </Heading>
      <Text>{author}</Text>
    </Container>
  </Box>
)

export default Quote
